import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Breakpoint } from '@capital-access/firefly/components';
import { ManagedByInstitution } from '@capital-access/ownership/common';
import { TARGETING_COMMON_KEY } from '../../constants';

@Component({
  selector: 'ca-managed-by',
  templateUrl: './ca-managed-by.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CaManagedByComponent {
  L10N = TARGETING_COMMON_KEY;
  @Input() institutions: ManagedByInstitution[] = [];
  @Input() popoverTitle!: string;

  get mobile(): boolean {
    return window.innerWidth < Breakpoint.Sm;
  }
}
